import StartingAndFindingEPCRs from '../pages/patientRecords/StartingAndFindingEPCRs'
import ClinicalModules from '../pages/patientRecords/ClinicalModules'
import ImagingRequests from '../pages/patientRecords/ImagingRequests'
import EPCRMobile from '../pages/patientRecords/EPCRMobile'
import ReviewingAndManagingPRFs from '../pages/patientRecords/ReviewingAndManagingPRFs'
import SharingAndAccessLogs from '../pages/patientRecords/SharingAndAccessLogs'
import RecordAudits from '../pages/patientRecords/RecordAudits'
import DopsAndLogbook from '../pages/patientRecords/DopsAndLogbook'
import SafeguardingAndHealthSafety from '../pages/patientRecords/SafeguardingAndHealthSafety'
import PatientFeedback from '../pages/patientRecords/PatientFeedback'

export default [
  {
    id: 'epcr',
    title: 'ePCR',
    pages: [
      {
        id: 'starting-and-finding',
        title: 'Starting and Finding ePCRs',
        summary:
          'Start a full ePCR, Fast Track, Welfare, or Critical Care record, resume drafts, review recents, link a CAD incident, pre-fill patient details from an event participant list, submission requirements, and practice mode.',
        component: StartingAndFindingEPCRs,
        tags: [
          'ePCR',
          'Fast Track',
          'Welfare',
          'Critical Care',
          'Record Types',
          'Drafts',
          'Recents',
          'CAD',
          'Practice',
          'Participant Lookup',
          'Bib Number',
        ],
      },
      {
        id: 'clinical-modules',
        title: 'Clinical Assessment and Treatment Modules',
        summary:
          'Reference for the assessment and treatment modules available inside a full ePCR, the three ways to record medicines, and the Critical Care live consoles.',
        component: ClinicalModules,
        tags: ['Assessment', 'Treatment', 'Vitals', 'NEWS2', 'PEWS', 'CRT', 'ECG', 'Medicines', 'Drawn-up', 'Airway', 'POC', 'Point of Care', 'Urinalysis', 'Blood Gas', 'Critical Care', 'Live Console'],
      },
      {
        id: 'imaging-requests',
        title: 'Imaging Requests',
        summary:
          'Enable imaging in Site Configuration, request X-ray and ultrasound studies from an ePCR, the approvers’ worklist and review drawer, scan images and clinical impressions, and per-employee radiation dose tracking.',
        component: ImagingRequests,
        tags: ['Imaging', 'X-ray', 'Ultrasound', 'Approval', 'Worklist', 'Radiation Dose', 'IR(ME)R', 'Site Configuration'],
      },
      {
        id: 'epcr-on-mobile',
        title: 'ePCR on the Mobile App',
        summary:
          'Completing ePCRs on the mobile app: offline drafts and sync, conflict resolution and detached records, module parity with the web app, Critical Care live consoles, deleting records, and what stays web-only.',
        component: EPCRMobile,
        tags: ['Mobile', 'Offline', 'Sync', 'Conflicts', 'Detached', 'Critical Care', 'NEWS2', 'PEWS', 'CRT', 'Treatment', 'Participant Lookup'],
      },
    ],
  },
  {
    id: 'patient-report-forms',
    title: 'Patient Report Forms',
    pages: [
      {
        id: 'reviewing-and-managing',
        title: 'Reviewing and Managing Patient Report Forms',
        summary:
          'The Care Records dashboard: stat tiles, the Records and Access log tabs, searching and filtering records, opening and reviewing a record, raising audits, reassigning, deleting, and uploading paper PRFs.',
        component: ReviewingAndManagingPRFs,
        tags: ['PRF', 'Paper PRF', 'Dashboard', 'Access Log', 'Reassign', 'Delete', 'Create Audit'],
      },
      {
        id: 'sharing-and-access-logs',
        title: 'Sharing and Access Logs',
        summary:
          'Attachments, share codes, revoking access, public access links, access logs, and Clinical Advice Line notes.',
        component: SharingAndAccessLogs,
        tags: ['Sharing', 'Share Code', 'Access Log', 'Public Access', 'CAL'],
      },
    ],
  },
  {
    id: 'clinical-quality',
    title: 'Clinical Quality',
    pages: [
      {
        id: 'record-audits',
        title: 'Record Audits',
        summary:
          'Quality audits of submitted records: tenant audit criteria that flag records at submission, critical care case review, raising audits by hand, the Governance workflow, and the clinician’s My Audits view.',
        component: RecordAudits,
        tags: [
          'Audit',
          'Audit Criteria',
          'Compliance',
          'Case Review',
          'My Audits',
          'Governance',
          'Random Sample',
        ],
      },
      {
        id: 'dops-and-logbook',
        title: 'DOPS and the Procedure Logbook',
        summary:
          'DOPS assessments requested from ePCR interventions, the assessor workflow, the automatic procedure logbook with skill currency, and the Governance oversight view.',
        component: DopsAndLogbook,
        tags: [
          'DOPS',
          'Procedure',
          'Logbook',
          'Skill Currency',
          'WPBA',
          'Assessment',
          'Reflection',
          'Governance',
        ],
      },
    ],
  },
  {
    id: 'safeguarding-feedback',
    title: 'Safeguarding and Feedback',
    pages: [
      {
        id: 'safeguarding-and-health-safety',
        title: 'Safeguarding and Health & Safety',
        summary:
          'Raising safeguarding concerns and health and safety incidents on an ePCR, and how the Governance team finds and reviews them.',
        component: SafeguardingAndHealthSafety,
        tags: ['Safeguarding', 'DSL', 'Health and Safety', 'Incident', 'Review'],
      },
      {
        id: 'patient-feedback',
        title: 'Patient Feedback',
        summary:
          'Public patient feedback submission, SMS invites that link feedback to the care record after surname/DOB confirmation, anonymous option, and internal governance review.',
        component: PatientFeedback,
        tags: [
          'Patient Feedback',
          'Governance',
          'Review',
          'SMS',
          'Care Record',
          'Anonymous',
          'GDPR',
        ],
      },
    ],
  },
]
